var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYygl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1680590719699,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 11934,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.5 845.3h833v50.4h-833z",
    "p-id": 11935,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M283 576h218v278.3H283V576z m143.2-195.4V452h-65.6v-71.4h-71.4V315h71.4v-71.4h65.6V315h71.4v65.6h-71.4z m247.2 86.3H754v73h-80.6v-73z m0 124.1H754v73h-80.6v-73z m0 124H754v73h-80.6v-73z m0 0",
    "p-id": 11936,
    fill: "#ffffff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M620.5 847.3h-50.4V214c0-19.5-14.1-35.3-31.4-35.3h-295c-17.3 0-31.4 15.8-31.4 35.3v633.4h-50.4V214c0-47.3 36.7-85.7 81.8-85.7h295c45.1 0 81.8 38.4 81.8 85.7v633.3z m0 0",
    "p-id": 11937,
    fill: "#ffffff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M857.4 851.8H807V426c0-6.3-4.3-11.8-9.3-11.8H605.9v-50.4h191.8c32.9 0 59.7 27.9 59.7 62.2v425.8z m0 0",
    "p-id": 11938,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYygl);
export default __webpack_public_path__ + "static/media/yygl.6b65b04b.svg";
export { ForwardRef as ReactComponent };